import { render, staticRenderFns } from "./BaseTableDetail.vue?vue&type=template&id=65e7a526&"
import script from "./BaseTableDetail.vue?vue&type=script&lang=js&"
export * from "./BaseTableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports